import script from "./add-project.vue?vue&type=script&setup=true&lang=js"
export * from "./add-project.vue?vue&type=script&setup=true&lang=js"

import "./add-project.vue?vue&type=style&index=0&id=54bb5468&lang=css"

const __exports__ = script;

export default __exports__